module.exports = __webpack_public_path__ + "img/6.870e941f.png";